"use client";

import React from "react";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import Radio from "./Radio";

/**
 * Gender seçimi için radio button component'i.
 * Mobilde border ile çerçeveli, desktop'ta normal görünüm.
 * React Hook Form ile uyumlu çalışır.
 *
 * @param {Object} props - Component props
 * @param {string} props.name - Form field adı (React Hook Form için)
 * @param {string} props.value - Seçili değer ("male" veya "female")
 * @param {function} props.onChange - Değer değiştiğinde çağrılacak callback (React Hook Form Controller ile kullanılır)
 * @param {string} [props.className] - Ekstra CSS sınıfları
 * @param {string} [props.error] - Hata mesajı
 * @param {boolean} [props.required=false] - Alanın zorunlu olup olmadığı
 * @param {Object} [props.rest] - Diğer tüm standart props'lar (register, vb.)
 */
const GenderSelect = ({
  name,
  value,
  onChange,
  className = "",
  error,
  required = false,
  disabled = false,
  ...rest
}) => {
  const t = useTranslationDetector("reservation");

  const handleChange = (selectedValue) => {
    if (!disabled && onChange) {
      // React Hook Form Controller için onChange direkt değeri alır
      onChange(selectedValue);
    }
  };

  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      {/* Radio Buttons Container - Border on mobile, normal on tablet/desktop */}
      <div className="border-border relative flex items-center gap-6 rounded-lg border px-4 py-4 sm:border-0 sm:px-0 sm:py-0">
        {/* Label */}
        <label className="text-foreground-subtle absolute -top-2 left-4 bg-white px-1 text-[12px] font-medium sm:hidden">
          {t("gender") || "Cinsiyet"}
        </label>
        <Radio
          {...rest}
          name={name}
          value="male"
          checked={value === "male"}
          onChange={() => handleChange("male")}
          disabled={disabled}
          className="flex-1 !items-center sm:flex-none"
          labelClassName="!text-base font-normal text-foreground"
        >
          {t("male")}
        </Radio>
        {/* Separator - Only visible on mobile */}
        <div className="bg-border h-6 w-px md:hidden" />
        <Radio
          {...rest}
          name={name}
          value="female"
          checked={value === "female"}
          onChange={() => handleChange("female")}
          disabled={disabled}
          className="flex-1 !items-center sm:flex-none"
          labelClassName="!text-base font-normal text-foreground"
        >
          {t("female")}
        </Radio>
      </div>
      {error && <span className="text-danger text-sm">{error}</span>}
    </div>
  );
};

export default GenderSelect;
